// PLACEHOLDER — Swap these for real customer testimonials when available.
// Each entry should have explicit permission to publish before going live.
// Until then, these read as honest early-access pilot quotes.

export const testimonials = [
  {
    id: 'salon-amina',
    industry: 'salons',
    quote:
      "We used to lose customers because we couldn't reply on WhatsApp fast enough. Now Botibonga handles everything: bookings, prices, opening hours, all without me lifting a finger.",
    author: 'Amina K.',
    role: 'Owner',
    company: 'Beauty studio (Nairobi)',
    metric: '4 hr → 30 sec response time',
  },
  {
    id: 'clinic-wanjiru',
    industry: 'clinics',
    quote:
      "Patients book appointments through WhatsApp at all hours. Botibonga answers their questions and slots them into the calendar. Our front desk is finally free to focus on the people in front of them.",
    author: 'Dr. Wanjiru N.',
    role: 'Practice manager',
    company: 'Family clinic (Kisumu)',
    metric: '+62 appointments / month',
  },
  {
    id: 'retail-james',
    industry: 'retail',
    quote:
      "Setup took 15 minutes. Within a week we were capturing twice as many leads from WhatsApp without paying for extra staff.",
    author: 'James M.',
    role: 'Operations lead',
    company: 'Boutique chain (Mombasa)',
    metric: '+40% qualified leads',
  },
];

export const customerCategories = [
  { label: 'Salons', icon: 'Scissors' },
  { label: 'Clinics', icon: 'Stethoscope' },
  { label: 'Retailers', icon: 'ShoppingBag' },
  { label: 'Consultancies', icon: 'Briefcase' },
  { label: 'Restaurants', icon: 'UtensilsCrossed' },
  { label: 'Real estate', icon: 'Building2' },
];
